// Synthetic event types an adapter can add to a student's telemetry so the replay can show
// pages that aren't the regular workspace (see reasoningGap/reasoningGapReplay.js). The
// workspace never logs these, so regular replays look exactly as before.
export const REPLAY_EVENTS = {
  // payload: { mode: 'screen' | 'banner', title, lines: [string], items: [string] }
  // 'screen' covers the editor (the student was on another screen, e.g. feedback);
  // 'banner' sits above it. A payload with mode 'none' clears it.
  NOTICE: 'REPLAY_NOTICE',
  // payload: { kind: 'submit' | 'paste' | 'copy' | 'away' | 'gap', label }: a timeline marker.
  MARKER: 'REPLAY_MARKER',
  // payload: { away: boolean, reason: 'tab' | 'window' }: the page was hidden or unfocused.
  AWAY: 'REPLAY_AWAY',
  // No payload: the page emptied its output panel (e.g. a reload).
  TERMINAL_CLEAR: 'REPLAY_TERMINAL_CLEAR',
}

// Optional payload fields adapters may set on the workspace's own events:
// TERMINAL_RUN.terminalLine (the line shown when the run starts, '' for none),
// TERMINAL_RUN.ranCode (the code that run executed, when it may differ from the editor),
// TERMINAL_OUTPUT.stream ('stderr' to show it as an error), and
// TEST_CASE_RESULT.terminalLine ('' when the results never appeared in the terminal).

